// 지원 로케일 키 목록. antd locale(ConfigProvider)은 D4-2 에서 제거됨(Modal.confirm→radix, 기본 텍스트 i18next).
// isAvailable/getAvailableLocale 은 키만 사용(store settings saga 소비).
export type LocaleKey = 'ko-KR' | 'en-US' | 'fr-FR' | 'ru-RU' | 'zh-CN' | 'ja-JP'

const LOCALE_KEYS: LocaleKey[] = ['ko-KR', 'en-US', 'fr-FR', 'ru-RU', 'zh-CN', 'ja-JP']

export function isAvailable(locale: string): boolean {
  return LOCALE_KEYS.includes(locale as LocaleKey)
}

export function getAvailableLocale(localeStr: string): LocaleKey {
  const val = LOCALE_KEYS.find((locale) => locale.indexOf(localeStr) === 0)
  return val ?? 'en-US'
}
